export default "__VITE_ASSET__CuP5jDBY__"